import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ngbd-confirm',
    template: `
    <!-- Delete Folder Modal -->

    <div class="modal-body">
      <div class="fc_modal_body">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          (click)="activeModal.close()"
        ></button>
        <h3 class="my-4 confirm_message"><span class="tpa_hide">Are you sure you want to delete</span>&nbsp;<span class="file_message">{{message}}</span><span class="tpa_hide">&nbsp;{{suffix}}</span></h3>
        <div
          class="form-group d-flex justify-content-between align-items-center"
        >
          <button
            type="button"
            class="border_btn"
            data-bs-dismiss="modal"
            (click)="activeModal.close()"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="primary_btn"
            (click)="activeModal.close(true)"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  `,
    styles: [
        `
      .modal-dialog {
        margin: 0 !important;
      }
      h3 {
        font-size:20px;
      }
      /* Filename highlight — mustard accent by default; the sage override
         lives in src/styles.css under body[data-theme="sage"] .file_message
         so the inline filename in the delete-confirm modal always matches
         the active dashboard theme. */
      .file_message{
        color: #d4a843 !important;
      }
    `,
    ],
    standalone: false
})
export class ConfirmDailogue {
  @Input() title = 'Confirmation';
  @Input() message = '';
  /** Trailing text after the message — defaults to "file?" for backward
   *  compatibility with the existing 11+ callers that delete files. Pass
   *  e.g. "event?" / "contact?" / "" to tailor the prompt. */
  @Input() suffix = 'file?';

  constructor(
    public activeModal: NgbActiveModal,
    public modalService: NgbModal
  ) {}
}
